import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ApplicationService from "services/ApplicationService";

const initialState = {
  loading: false,
  error: null,
  data: null,
};

export const createApplication = createAsyncThunk(
  "application/create",
  async (applicationData, thunkAPI) => {
    try {
      const response = await ApplicationService.createApplication(
        applicationData
      );
      console.log(response.data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 403) {
        return thunkAPI.rejectWithValue(
          "Le statut du compte babysitter n'est pas actif."
        );
      }
      if (error.response?.status === 405) {
        return thunkAPI.rejectWithValue(error.response?.data?.message);
      }

      return thunkAPI.rejectWithValue(
        error.response?.data?.data?.message || "Erreur"
      );
    }
  }
);

// export const getAllApplications = createAsyncThunk(
//   "application/getAll",
//   async (_, thunkAPI) => {
//     try {
//       const response = await api.get("/applications");
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );

// export const getApplicationById = createAsyncThunk(
//   "application/getById",
//   async (applicationId, thunkAPI) => {
//     try {
//       const response = await api.get(`/applications/${applicationId}`);
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );

// export const deleteApplication = createAsyncThunk(
//   "application/delete",
//   async (applicationId, thunkAPI) => {
//     try {
//       await api.delete(`/applications/${applicationId}`);
//       return applicationId;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );

const applicationSlice = createSlice({
  name: "application",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetApplicationStatus: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createApplication.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createApplication.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createApplication.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    //   .addCase(getAllApplications.pending, (state) => {
    //     state.loading = true;
    //     state.error = null;
    //   })
    //   .addCase(getAllApplications.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.data = action.payload;
    //   })
    //   .addCase(getAllApplications.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.payload;
    //   })
    //   .addCase(getApplicationById.pending, (state) => {
    //     state.loading = true;
    //     state.error = null;
    //   })
    //   .addCase(getApplicationById.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.data = action.payload;
    //   })
    //   .addCase(getApplicationById.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.payload;
    //   })
    //   .addCase(deleteApplication.pending, (state) => {
    //     state.loading = true;
    //     state.error = null;
    //   })
    //   .addCase(deleteApplication.fulfilled, (state, action) => {
    //     state.loading = false;
    //     // Remove the deleted application from the state
    //     state.data = state.data.filter(
    //       (application) => application.id !== action.payload
    //     );
    //   })
    //   .addCase(deleteApplication.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.payload;
    //   });
  },
});
export const { resetApplicationStatus } = applicationSlice.actions;
export default applicationSlice.reducer;
